// Sistema simples de event emitter para atualizar dados REDEMET

const listeners = new Set();

export const onRadarUpdate = (callback) => {
  listeners.add(callback);
  return () => listeners.delete(callback); // retorna função para remover listener
};

export const emitRadarUpdate = () => {
  listeners.forEach(callback => callback());
};
